define(['jQuery', '../blocks/notify-manager/notify-manager', 'Emitter'], (
    $,
    BNotifyManager,
    Emitter,
) => {
    let instance;

    function NotifyManager() {
        if (instance) {
            return instance;
        }

        this._manager = new BNotifyManager({
            renderMode: 'replace',
            el: $('<div/>').appendTo($('.mcs-app')),
        });

        this._manager.render();

        instance = this;
    }

    window.NotifyManager = NotifyManager;

    NotifyManager.fn = NotifyManager.prototype = {
        add(settings) {
            return this._manager.add(settings);
        },
    };

    NotifyManager.add = function({ type, message, link, html }) {
        new NotifyManager().add({
            type,
            message,
            html,
            link,
        });
    };

    NotifyManager.success = function(message, html = true) {
        NotifyManager.add({ type: 'success', message, html });
    };

    NotifyManager.error = function(message, html = true) {
        NotifyManager.add({ type: 'error', message, html });
    };

    Emitter.apply(NotifyManager.fn);

    return NotifyManager;
});
